import { render, staticRenderFns } from "./PurchaseDetail.vue?vue&type=template&id=beda6692&scoped=true"
import script from "./PurchaseDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDetail.vue?vue&type=style&index=0&id=beda6692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beda6692",
  null
  
)

export default component.exports